import type { RentTermsResponseDto } from '@zg-rentals/ts-rent-payment-client';

import RentAmountChangeModel from './RentAmountChange';
import NextPayable from './NextPayable';
import { INextPayableNumericInputModel } from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';
import { toUTCTimestamp } from '@common/paymentsUtils/dateUtils';

export default (
  rentTerms: RentTermsResponseDto,
  endDateForPayments: number,
  nextPayable: INextPayableNumericInputModel,
  today: Date = new Date(),
) => {
  const {
    amount = 0,
    address = '',
    firstDueDate,
    monthToMonth = false,
    numberOfPayments = 12,
    dueLastDayOfMonth = false,
    rentAmountChangeRequest = {},
    rentTermsKey = '',
    paymentDateForFirstMonth,
    monthlyPaymentDate,
  } = rentTerms;

  return {
    amount: amount && Number(amount),
    address: address && String(address),
    firstDueDate: formatTimestampToYMDString(toUTCTimestamp(firstDueDate)),
    monthToMonth: Boolean(monthToMonth),
    numberOfPayments: numberOfPayments && Number(numberOfPayments),
    dueLastDayOfMonth: Boolean(dueLastDayOfMonth),
    paymentDateForFirstMonth: formatTimestampToYMDString(toUTCTimestamp(paymentDateForFirstMonth)),
    rentAmountChangeRequest: RentAmountChangeModel(
      rentAmountChangeRequest,
      formatTimestampToYMDString(toUTCTimestamp(firstDueDate)),
      formatTimestampToYMDString(endDateForPayments),
      NextPayable(nextPayable),
      today,
      monthlyPaymentDate,
    ),
    rentTermsKey: rentTermsKey && String(rentTermsKey),
  };
};
